var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConversationSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#3D505A",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.674 18.6671C25.0906 18.6671 23.5428 19.1367 22.2264 20.0164C20.9099 20.8961 19.8838 22.1465 19.2779 23.6094C18.672 25.0723 18.5134 26.682 18.8223 28.235C19.1312 29.788 19.8937 31.2145 21.0132 32.3342C22.1328 33.4538 23.5593 34.2163 25.1122 34.5252C26.6651 34.8342 28.2747 34.6756 29.7375 34.0697C31.2003 33.4637 32.4506 32.4376 33.3303 31.121C34.2099 29.8044 34.6794 28.2565 34.6794 26.6731C34.6794 24.5498 33.836 22.5134 32.3347 21.012C30.8334 19.5106 28.7971 18.6671 26.674 18.6671ZM16 26.6731C16.0002 24.9743 16.4059 23.3001 17.1833 21.7897C17.9606 20.2792 19.0872 18.9761 20.4695 17.9886C21.8517 17.0011 23.4496 16.3579 25.1304 16.1122C26.8113 15.8665 28.5264 16.0256 30.1334 16.5762C31.7404 17.1268 33.1928 18.053 34.3699 19.2778C35.5469 20.5026 36.4147 21.9907 36.9011 23.6184C37.3874 25.2461 37.4783 26.9663 37.1661 28.6362C36.854 30.306 36.1478 31.8773 35.1064 33.2193L39.6255 37.7387C39.8685 37.9904 40.003 38.3274 39.9999 38.6773C39.9969 39.0271 39.8566 39.3618 39.6092 39.6092C39.3618 39.8566 39.0272 39.9969 38.6773 39.9999C38.3275 40.003 37.9905 39.8685 37.7388 39.6254L33.2198 35.1061C31.642 36.3311 29.7521 37.0888 27.7651 37.293C25.778 37.4972 23.7736 37.1397 21.9796 36.2612C20.1857 35.3826 18.6742 34.0183 17.6171 32.3233C16.5601 30.6283 15.9998 28.6707 16 26.6731Z",
    fill: "#3D505A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversationSearch);
export default __webpack_public_path__ + "static/media/icon-conversation-search.ed9234414c342f86669e949b8abb4b11.svg";
export { ForwardRef as ReactComponent };